var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{
        name: 'single_permission',
        params: { id: _vm.props.item.id }
      }}},[_vm._v("\n      "+_vm._s(_vm.props.item.name)+"\n    ")])],1),_c('td',[_vm._v("\n    "+_vm._s(_vm.props.item.code)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.scope)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }